import React from 'react'

function Contect() {
  return (
  <>
  {/* Contact */}
<section className="section contact">
  <div className="row">
    <div className="col">
      <h2>EXCELLENT SUPPORT</h2>
      <p>We love our customers and they can reach us any time
        of day we will be at your service 24/7</p>
      <a href className="btn btn-1">Contact</a>
    </div>
    <div className="col">
      <form action>
        <div>
          <input type="email" placeholder="Email Address" />
          <a href>Send</a>
        </div>
      </form>
    </div>
  </div>
</section>

  </>
  )
}

export default Contect
